import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div data-testid="atelier-loading" className="min-h-screen flex items-center justify-center bg-obsidian">
        <p className="label-eyebrow text-lavender animate-pulse">Unlocking the atelier…</p>
      </div>
    );
  }
  if (status === "anonymous") {
    return <Navigate to="/atelier/login" replace state={{ from: location }} />;
  }
  return children;
}
